// Como cada campo padrão do produto é exibido na tabela e editado no formulário.
export const STANDARD_FIELD_TYPES = {
  sku: 'text',
  product_group_id: 'group',
  price: 'money',
  description: 'textarea',
  unit: 'unit',
  special_price: 'money',
  wholesale_price: 'money',
  loyalty_points: 'integer',
  image: 'image',
};

// Chave do campo padrão (snake_case) → propriedade do produto no front (camelCase).
const STANDARD_VALUE_KEYS = {
  sku: 'sku',
  product_group_id: 'productGroupName',
  price: 'price',
  description: 'description',
  unit: 'unit',
  special_price: 'specialPrice',
  wholesale_price: 'wholesalePrice',
  loyalty_points: 'loyaltyPoints',
};

export const formatMoney = value =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(
    Number(value) || 0
  );

const formatCustomValue = (attribute, value, labels) => {
  if (value === undefined || value === null || value === '') return '';
  if (attribute.attributeDisplayType === 'checkbox') {
    return value === true || value === 'true' ? labels.yes : labels.no;
  }
  if (attribute.attributeDisplayType === 'currency') return formatMoney(value);
  if (Array.isArray(value)) return value.join(', ');
  return String(value);
};

// Texto da célula; a imagem é desenhada à parte (precisa de <img>).
export const cellText = (product, field, labels) => {
  if (field.type === 'custom') {
    return formatCustomValue(
      field.attribute,
      product.customAttributes?.[field.key],
      labels
    );
  }
  const value = product[STANDARD_VALUE_KEYS[field.key]];
  if (STANDARD_FIELD_TYPES[field.key] === 'money') return formatMoney(value);
  return value ?? '';
};
